import React from 'react';
import './Dashboard.css';

const vuesaxRedIcon = '/assets/vuesax-red.svg';
const vuesaxblackIcon = '/assets/vuesax-black.svg';
const infoRedIcon = '/assets/info-red.svg';
const infoBlackIcon = '/assets/info-black.svg';
const dotIcon = '/assets/dot.svg';
const archiveTickIcon = '/assets/archive-tick.svg';

const Dashboard = () => {
    return (
        <div className='dashboard-container'>
            <div className='dashboard-main_2'>
                {/* Copy and Use  */}
                <div className='dashboard-tabel'>
                    <div className='dashboard-text'>
                        <div className='dashboard-container-main'>
                            <div className='dashboard-div div-first'>
                                <img
                                    className='dashboard-img-first'
                                    src={vuesaxRedIcon}
                                    alt='vuesaxRedIcon'
                                    height={25}
                                    width={25}
                                />
                                <img
                                    className='dashboard-img-second'
                                    src={infoRedIcon}
                                    alt='vuesaxRedIcon'
                                    height={16}
                                    width={16}
                                />
                                <p className='dashboard-div-p'>
                                    Analyse call <br /> against <br />{' '}
                                    guidelines <br />
                                </p>
                                <div className='dashboard-div-hr div-first-hr'></div>
                                <p className='dashboard-div-actions'>
                                    Copy and Use
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Action */}
                <div className='dashboard-tabel'>
                    <div className='dashboard-text'>
                        <div className='dashboard-container-main'>
                            <div className='dashboard-div div-second'>
                                <img
                                    className='dashboard-img-first'
                                    src={vuesaxblackIcon}
                                    alt='vuesaxblackIcon'
                                    height={25}
                                    width={25}
                                />
                                <img
                                    className='dashboard-img-second'
                                    src={dotIcon}
                                    alt='dotIcon'
                                    height={16}
                                    width={16}
                                />
                                <img
                                    className='dashboard-img-second'
                                    src={archiveTickIcon}
                                    alt='archiveTickIcon'
                                    height={16}
                                    width={16}
                                />
                                <img
                                    className='dashboard-img-second'
                                    src={infoBlackIcon}
                                    alt='infoBlackIcon'
                                    height={16}
                                    width={16}
                                />
                                <p className='dashboard-div-p'>
                                    Client <br /> Feedback <br />
                                </p>
                                <div className='dashboard-div-hr div-second-hr'></div>
                                <p className='dashboard-div-actions'>Action</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Total QuickActions */}
                <div className='dashboard-tabel'>
                    <div className='dashboard-text'>
                        <div className='dashboard-container-main'>
                            <div className='dashboard-div-third'>
                                <div className='dashboard-top'></div>
                                <div className='dashboard-head'>
                                    <div className='dashboard-div-icon'>
                                        <b>Created:</b> 12-10-2023 12:34 pm
                                    </div>
                                    <div className='dashboard-div-dot2'>
                                        <img
                                            src={dotIcon}
                                            alt='dotIcon'
                                            height={20}
                                            width={20}
                                        />
                                    </div>
                                </div>
                                <div className='dashboard-div-info'>
                                    <h1>Internal</h1>
                                    <p>
                                        Total QuickActions<span> 05</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Dashboard;
